import { cn } from "@/lib/utils";

export function Field({
  label,
  children,
  className,
}: { label: string; children: React.ReactNode; className?: string }) {
  return (
    <label className={cn("flex flex-col gap-1", className)}>
      <span className="field-label">{label}</span>
      {children}
    </label>
  );
}
